import { render } from "./households.vue?vue&type=template&id=00fef9de"
import script from "./households.vue?vue&type=script&lang=js"
export * from "./households.vue?vue&type=script&lang=js"

import "./households.vue?vue&type=style&index=0&id=00fef9de&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__